__turbopack_context__.v({
  "Cont": "Project-module-sass-module__K6VBUq__Cont",
  "Content": "Project-module-sass-module__K6VBUq__Content",
  "Image": "Project-module-sass-module__K6VBUq__Image",
  "Project": "Project-module-sass-module__K6VBUq__Project",
  "ProjectDetails": "Project-module-sass-module__K6VBUq__ProjectDetails",
  "Summary": "Project-module-sass-module__K6VBUq__Summary",
});
